module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-brochure-page"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "landing-page-wrapper download-brochure-hero",
    staticStyle: {
      "overflow": "visible"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "landing-page-section"
  }, [_c('div', {
    staticClass: "landing-page-hero"
  }, [(!_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-title"
  }, [_vm._v("\n              " + _vm._s(_vm.content.heroSection.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "landing-page-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-description"
  }, [_vm._v("\n              " + _vm._s(_vm.content.heroSection.description) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "landing-page-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-download-request"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brochureRequest.email),
      expression: "brochureRequest.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "type": "email",
      "name": "Email",
      "placeholder": "Write your email address..."
    },
    domProps: {
      "value": (_vm.brochureRequest.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brochureRequest, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    class: [{
      'disabled': this.errors.has('Email')
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.requestBrochure()
      }
    }
  }, [_vm._v("Get brochure")])]), _vm._v(" "), _c('div', {
    staticClass: "download-subscribe"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brochureRequest.subscribe),
      expression: "brochureRequest.subscribe"
    }],
    attrs: {
      "type": "checkbox",
      "id": "subscribe"
    },
    domProps: {
      "checked": Array.isArray(_vm.brochureRequest.subscribe) ? _vm._i(_vm.brochureRequest.subscribe, null) > -1 : (_vm.brochureRequest.subscribe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.brochureRequest.subscribe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.brochureRequest, "subscribe", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.brochureRequest, "subscribe", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.brochureRequest, "subscribe", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "subscribe"
    }
  }, [_vm._v("Subscribe me to the newsletter")])]), _vm._v(" "), (_vm.brochureRequest.subscribe) ? _c('div', {
    staticClass: "download-subscribe-info"
  }, [_c('strong', [_vm._v("Privacy:")]), _vm._v(" Your details will be used to keep you informed about resources provided by The Clear Company.\n              "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy-policy'
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" to find out more about the services we provide.\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.brochureRequest.shown) ? _c('div', {
    staticClass: "request-status",
    class: _vm.brochureRequest.success ? 'success' : 'error'
  }, [_vm._v("\n              " + _vm._s(_vm.brochureRequest.message) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-wrapper download-brochure-summary"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "landing-page-section"
  }, [_c('div', {
    staticClass: "landing-page-summary"
  }, [(!_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-summary__title"
  }, [_vm._v("\n              " + _vm._s(_vm.content.contentSection.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contentSection.title),
      expression: "content.contentSection.title"
    }],
    staticClass: "landing-page-summary__title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contentSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contentSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.contentSection.title))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "landing-page-summary__items"
  }, _vm._l((_vm.content.contentSection.summary), function(item, index) {
    return _c('li', {
      staticClass: "landing-page-summary__item"
    }, [(!_vm.pageEditMode) ? _c('span', {
      staticClass: "landing-page-summary__item"
    }, [_vm._v(_vm._s(item.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "landing-page-summary__item",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Summary item",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.contentSection.summary, index)
        }
      }
    }) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection(_vm.content.contentSection.summary)
      }
    }
  }, [_vm._v("+ Add item")]) : _vm._e()])])])])]), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1700bc1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/DownloadBrochure.vue
// module id = 895
// module chunks = 1